const cache = new Map<string, Intl.NumberFormat>();

function getFormatter(currency: string, locale: string) {
  const key = `${locale}-${currency}`;
  let fmt = cache.get(key);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    cache.set(key, fmt);
  }
  return fmt;
}

export function useCurrency(options?: { defaultCurrency?: string; locale?: string }) {
  const defaultCurrency =
    options?.defaultCurrency || (typeof navigator !== 'undefined' ? 'USD' : 'USD');
  const locale =
    options?.locale || (typeof navigator !== 'undefined' ? navigator.language : 'en-US');

  function formatMoney(amount: number | string, currency?: string, loc?: string) {
    const n = typeof amount === 'string' ? Number(amount) : amount;
    const fmt = getFormatter(currency || defaultCurrency, loc || locale);
    return fmt.format(isFinite(n as number) ? (n as number) : 0);
  }

  return { formatMoney };
}
